import { render, staticRenderFns } from "./customerServiceQuery.vue?vue&type=template&id=6bbc0727&"
import script from "./customerServiceQuery.vue?vue&type=script&lang=js&"
export * from "./customerServiceQuery.vue?vue&type=script&lang=js&"
import style0 from "./customerServiceQuery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports